/// <amd-module name="Search/WorkItem/Components/RightPane/PreviewNotificationContainer" />
import * as React from "react";
import * as Resources from "Search/WorkItem/Resources";
import * as Container from "Search/Shared/Base/Container";
import { ActionCreator } from "Search/WorkItem/Flux/ActionCreator";
import { StoresHub, IAggregatedState, StoreName } from "Search/WorkItem/Flux/StoresHub"
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { WorkitemPreviewPaneScenario } from "Search/WorkItem/Flux/Stores/PreviewNotificationStore";

export const PreviewNotificationContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub>(
    [
        "previewNotificationStore"
    ],
    ({
        previewNotificationStoreState
    }, props) => {
        const { dismissBanner } = props.actionCreator;
        const { workItemPreviewBannerState } = previewNotificationStoreState;
        return (
            workItemPreviewBannerState !== WorkitemPreviewPaneScenario.None ? (
                <MessageBar
                    severity={MessageBarSeverity.Warning}
                    onDismiss={dismissBanner}>
                    {
                        workItemPreviewBannerState === WorkitemPreviewPaneScenario.Stale ?
                            Resources.WorkItemOudatedIndexMessage
                            : Resources.WorkItemDeletedMessage
                    }
                </MessageBar>
            ) : null
        );
    }
);